import type { FeedbackMessages } from './en';

const uk: FeedbackMessages = {
  qualified: {
    title: 'Дякуємо Вам за участь у цьому опитуванні!',
    body1: 'Ви можете закрити вікно браузера.',
    body2: 'Сподіваємося побачити Вас знову найближчим часом.',
    refCode: 'Референтний код: {code}',
  },
  quotaFull: {
    title: 'Це опитування закрито',
    body1: 'Дякуємо Вам за інтерес до нашого опитування.',
    body2: 'На жаль, ми вже отримали всі необхідні відповіді.',
    body3: 'Сподіваємося побачити Вас в одному з наших майбутніх опитувань!',
    refCode: 'Референтний код: {code}',
  },
  terminated: {
    title: 'Дякуємо Вам за те, що поділилися своєю думкою!',
    body1:
      'Сподіваємося побачити Вас найближчим часом у наших майбутніх опитуваннях. А до того бажаємо Вам чудового дня.',
    body2: 'Будь ласка, закрийте це вікно браузера.',
    refCode: 'Референтний код: {code}',
  },
  mismatch: {
    title: 'Дякуємо Вам за інтерес',
    body1: 'На жаль, Ви не належите до цільової групи цього конкретного опитування.',
    body2: 'Ви можете закрити цю сторінку.',
    code: 'Код: {code}',
  },
  error: {
    title: 'Ми не можемо обробити Ваш запит',
    linkProblemDetailed:
      'З посиланням, яким Ви скористалися, виникли проблеми. Будь ласка, перевірте, чи посилання в адресному рядку відповідає тому, яке Вам було надано, і спробуйте ще раз.',
    linkProblemGeneric:
      'З посиланням, яким Ви скористалися, виникли проблеми. Будь ласка, спробуйте ще раз.',
    contactPerson:
      'Якщо проблема не зникає, будь ласка, повідомте про це особу, від якої Ви отримали посилання.',
    errorCode: 'Код помилки: {code}',
  },
};

export default uk;
